import { PropertyMapper } from '../../decorators';
import { User } from '../user/user.model';

export class AuthModel extends User {

    @PropertyMapper()
    token: string;
}
